import {API_HOST} from '../config.env';
import axios from 'axios';
import debut from '../images/actions/debut.svg';
import tir from '../images/actions/tir.svg';
import cartonJaune from '../images/actions/jaune.png';
import cartonRouge from '../images/actions/rouge.png';
import cartonBlanc from '../images/actions/blanc.png';
import cpa from '../images/actions/cpa.svg';
import but from '../images/actions/but.svg';
import penalty from '../images/actions/penalty.svg';
import mitemps from '../images/actions/mitemps.svg';
import reprise from '../images/actions/reprise.svg';
import fin from '../images/actions/fin.svg';
import remplacement from '../images/actions/remplacement.svg';
import prolongation from '../images/actions/prolong.svg'
import { isDemo } from '../helpers';

const headers = access => {
    return {
        headers: {
            Accept: 'application/ld+json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access}`
        }
    }
}

export const getIcon = label => {
    switch(label){
        case 'debut':
            return debut;
        case 'tir':
            return tir;
        case 'carton-jaune':
            return cartonJaune;
        case 'carton-rouge':
            return cartonRouge;
        case 'carton-blanc':
            return cartonBlanc;
        case 'coup-de-pied-arrete':
            return cpa;
        case 'but':
        case 'penalty_resultat-marque':
            return but;
        case 'penalty_declaration':
        case 'penalty_resultat-arrete': 
        case 'penalty_resultat-manque':
            return penalty;
        case 'mi_temps':
        case 'mi_temps_prolongation':
            return mitemps;
        case 'reprise':
        case 'reprise_prolongation':
            return reprise;
        case 'fin_de_match':
        case 'fin_temps_reglementaire':
        case 'fin_prolongations':
            return fin;
        case 'remplacement':
            return remplacement;
        case 'prolongations':
            return prolongation;
        default: return
    }    
}

export const editAction = (action, body, access, live, actionId) => {
    if(isDemo(live)) {
        return new Promise((resolve, reject) => {
            resolve({data: {
                '@id': action,
                data: body.data,
                minute: body.minute,
                teamId: body.teamId,
                teamName: body.teamName,
                live: `/api/actions/${live}`,
                type: actionId
            }})
        });
    }
    return axios.put(`${API_HOST}${action}`,body, headers(access));
}

export const removeAction = (action, access, live) => isDemo(live) ? new Promise((resolve, reject) => resolve()) : axios.delete(`${API_HOST}${action}`, headers(access));